<template>
  <div class="row">
    <div class="col-xl-12 order-xl-1">
      <card card-body-classes="table-full-width" no-footer-line>

        <div class="over600">
          <h4 class="card-title ml-3" style="margin-top: 0!important; margin-bottom: 0!important;">{{ locale.work_shifts }}</h4>
          <div>
            <div v-if="logged_user_role === 'Admin'"
                 class="d-flex flex-row ml-3 mb-3"
            >
              <br>
              <el-date-picker
                  v-model="selected_week"
                  type="week"
                  format="[W week]"
                  :picker-options="{firstDayOfWeek: 1}"
                  v-bind:placeholder="locale.pick_a_week"
                  @change="getWUFiltered()"
              />
              <el-date-picker
                  v-model="selected_date_range"
                  type="daterange"
                  class="pt-0 ml-3"
                  :picker-options="{firstDayOfWeek: 1}"
                  popper-class="custom-date-picker"
                  v-bind:start-placeholder="locale.start_date"
                  v-bind:end-placeholder="locale.end_date"
                  @change="getWUFiltered()"
              />
              <br>
            </div>
            <div class="d-flex flex-row">
              <div class="flex-column w-20 ml-3">
                <n-button class="print-button-container  mt-0" v-if="logged_user_role === 'Admin'"
                          @click.native="printTable('shits-table')"
                >{{ locale.print }}
                </n-button>
                <n-button class="print-button-container  mt-0" v-if="logged_user_role === 'Admin'"
                          @click.native="exportExcel()"
                >{{ locale.export_excel }}
                </n-button>
              </div>
              <div class="flex-column w-75" style="font-size: 18px; padding: 10px;">
                <p v-if="for_which === 'workers'"><b>{{ this.locale.employment_number }}: </b>{{this.selected_worker_info['employment_number']}} <b class="pl-5">{{ this.locale.name }}: </b>
                  {{this.selected_worker_info['first_name'] + ' ' + this.selected_worker_info['last_name']}}
                  <b class="pl-5">{{ this.locale.personal_no }}: </b>{{this.selected_worker_info['personal_id_no']}} <b class="pl-5">{{
                      this.locale.address_line1
                    }}: </b>
                  {{this.selected_worker_info['address_line1']}} <b class="pl-5">{{ this.locale.address_line2 }}: </b>{{this.selected_worker_info['address_line2']}}
                  <b class="pl-5">{{ this.locale.postal_code }}: </b>
                  {{this.selected_worker_info['postal_code']}} <b class="pl-5">{{ this.locale.city_name }}: </b>{{this.selected_worker_info['city']}}</p>

                <p v-if="for_which === 'projects'"><b>{{ this.locale.own_project_number }}: </b>{{this.selected_project_info['own_project_number']}} <b class="pl-5">{{ this.locale.name }}: </b>
                  {{this.selected_project_info['name']}}
                  <b class="pl-5">{{ this.locale.client_project_number }}: </b>{{this.selected_project_info['client_project_number']}} <b class="pl-5">{{
                      this.locale.address
                    }}: </b>
                  {{this.selected_project_info['full_address']}}</p>

                <p v-if="for_which === 'clients'"><b>{{ this.locale.registered_no }}: </b>{{this.selected_client_info['registered_no']}} <b class="pl-5">{{ this.locale.name }}: </b>
                  {{this.selected_client_info['name']}}
                  <b class="pl-5">{{ this.locale.phone }}: </b>{{this.selected_client_info['client_phone_number']}} <b class="pl-5">{{
                      this.locale.address
                    }}: </b>
                  {{this.selected_client_info['full_address']}}</p>
              </div>
              <div class="flex-column w-20 mr-3"  v-if="logged_user_role === 'Admin' && for_which !=='clients'">
                <n-button
                    type="primary"
                    class="btn btn-sm btn-primary"
                    @click.native="onAddWorkUnit()"
                >
                  <span>{{ locale.add_work_unit }}</span>
                </n-button>
              </div>
            </div>
          </div>
        </div>
        <div class="below600">
          <div class="row mx-3 justify-content-between mb-2">
            <div class="d-flex flex-column  justify-content-start">
            <h4 class="card-title" style="margin-top: 0!important; margin-bottom: 0!important;">{{ locale.work_shifts }}</h4>
            </div>
            <div class="d-flex flex-column  justify-content-start" style="align-items: flex-end!important;">
              <n-button
                  type="primary"
                  class="btn btn-sm btn-primary"
                  style="margin-top: 0!important"
                  @click.native="onAddWorkUnit()"
              >
                <span class="over400">{{ locale.add_work_unit }}</span>
                <span class="below400">+</span>
              </n-button>
            </div>
          </div>
              <div v-if="logged_user_role === 'Admin'"
               class="d-flex flex-row mx-3 mb-3"
          >
            <br>
            <el-date-picker
                v-model="selected_date_range"
                type="daterange"
                class="pt-0"
                :picker-options="{firstDayOfWeek: 1}"
                popper-class="custom-date-picker"
                v-bind:start-placeholder="locale.start_date"
                v-bind:end-placeholder="locale.end_date"
                @change="getWUFiltered()"
            />
            <br>
          </div>
          <div v-if="logged_user_role === 'Admin'"
               class="d-flex flex-row mx-3 mb-3 justify-content-between"
          >
                        <el-date-picker
                            v-model="selected_week"
                            type="week"
                            format="[W week]"
                            :picker-options="{firstDayOfWeek: 1}"
                            v-bind:placeholder="locale.pick_a_week"
                            @change="getWUFiltered()"
                        />
            <div    class="d-flex flex-row justify-content-between"
            >            <n-button v-if="logged_user_role === 'Admin'"
                                   type="secondary"
                                   class="btn btn-sm btn-secondary mx-2"
                                   style="margin-top : 0!important; margin-bottom: 0!important;"
                                   @click.native="printTable('shits-table')"
            >
              <i class="el-icon-printer"></i>
            </n-button>
              <n-button v-if="logged_user_role === 'Admin'"
                        type="secondary"
                        class="btn btn-sm btn-secondary"
                        style="margin: 0!important"
                        @click.native="exportExcel()"
              >
                <i class="fa fa-file-excel-o"></i>
              </n-button>
            </div>
          </div>
          <div class="flex-column mx-3" style="font-size: 18px;" v-if="for_which ==='workers'">
            <div class="flex-row d-flex" >
              <b>{{ this.locale.employment_number }}: </b>
              <p class="ml-2">{{this.selected_worker_info['employment_number']}}&nbsp;</p>
            </div>
            <div class="flex-row d-flex" >
              <b>{{ this.locale.name }}: </b>
              <p class="ml-2"> {{this.selected_worker_info['first_name'] + ' ' + this.selected_worker_info['last_name']}}&nbsp;</p>
            </div>
            <div class="flex-row d-flex">
              <b>{{ this.locale.personal_no }}: </b>
              <p class="ml-2"> {{this.selected_worker_info['personal_id_no']}}&nbsp; </p>
            </div>
            <div class="flex-row d-flex">
              <b>{{this.locale.address_line1 }}:</b>
              <p class="ml-2"> {{this.selected_worker_info['address_line1']}}&nbsp;</p>
            </div>
            <div class="flex-row d-flex">
              <b>{{this.locale.address_line2 }}:</b>
              <p class="ml-2"> {{this.selected_worker_info['address_line2']}}&nbsp;</p>
            </div>
            <div class="flex-row d-flex">
              <b>{{ this.locale.postal_code }}: </b>
              <p class="ml-2"> {{this.selected_worker_info['postal_code']}}&nbsp;</p>
            </div>
            <div class="flex-row d-flex">
              <b>{{ this.locale.city_name }}: </b>
              <p class="ml-2"> {{this.selected_worker_info['city']}}&nbsp;</p>
            </div>
          </div>

          <div class="flex-column mx-3" style="font-size: 18px;" v-if="for_which ==='projects'">
            <div class="flex-row d-flex" >
              <b>{{ this.locale.own_project_number }}: </b>
              <p class="ml-2">{{this.selected_project_info['own_project_number']}}&nbsp;</p>
            </div>
            <div class="flex-row d-flex" >
              <b>{{ this.locale.name }}: </b>
              <p class="ml-2">{{this.selected_project_info['name']}}&nbsp;</p>
            </div>
            <div class="flex-row d-flex" >
              <b>{{ this.locale.client_project_number }}: </b>
              <p class="ml-2">{{this.selected_project_info['client_project_number']}}&nbsp;</p>
            </div>
            <div class="flex-row d-flex" >
              <b>{{ this.locale.address }}: </b>
              <p class="ml-2">{{this.selected_project_info['full_address']}}&nbsp;</p>
            </div>
          </div>

          <div class="flex-column mx-3" style="font-size: 18px;" v-if="for_which ==='clients'">
            <div class="flex-row d-flex" >
              <b>{{ this.locale.Org_nummer }}: </b>
              <p class="ml-2">{{this.selected_client_info['registered_no']}}&nbsp;</p>
            </div>
            <div class="flex-row d-flex" >
              <b>{{ this.locale.name }}: </b>
              <p class="ml-2">{{this.selected_client_info['name']}}&nbsp;</p>
            </div>
            <div class="flex-row d-flex" >
              <b>{{ this.locale.phone }}: </b>
              <p class="ml-2">{{this.selected_client_info['client_phone_number']}}&nbsp;</p>
            </div>
            <div class="flex-row d-flex" >
              <b>{{ this.locale.address }}: </b>
              <p class="ml-2">{{this.selected_client_info['full_address']}}&nbsp;</p>
            </div>
          </div>
          <!--            <p v-if="for_which === 'workers'"><b>{{ this.locale.employment_number }}: </b>{{this.selected_worker_info['employment_number']}} <b class="pl-5">{{ this.locale.name }}: </b>-->
<!--              {{this.selected_worker_info['first_name'] + ' ' + this.selected_worker_info['last_name']}}-->
<!--              <b class="pl-5">{{ this.locale.personal_no }}: </b>{{this.selected_worker_info['personal_id_no']}} <b class="pl-5">{{-->
<!--                  this.locale.address_line1-->
<!--                }}: </b>-->
<!--              {{this.selected_worker_info['address_line1']}} <b class="pl-5">{{ this.locale.address_line2 }}: </b>{{this.selected_worker_info['address_line2']}}-->
<!--              <b class="pl-5">{{ this.locale.postal_code }}: </b>-->
<!--              {{this.selected_worker_info['postal_code']}} <b class="pl-5">{{ this.locale.city_name }}: </b>{{this.selected_worker_info['city']}}</p>-->

<!--            <p v-if="for_which === 'projects'"><b>{{ this.locale.own_project_number }}: </b>{{this.selected_project_info['own_project_number']}} <b class="pl-5">{{ this.locale.name }}: </b>-->
<!--              {{this.selected_project_info['name']}}-->
<!--              <b class="pl-5">{{ this.locale.client_project_number }}: </b>{{this.selected_project_info['client_project_number']}} <b class="pl-5">{{-->
<!--                  this.locale.address-->
<!--                }}: </b>-->
<!--              {{this.selected_project_info['full_address']}}</p>-->

<!--            <p v-if="for_which === 'clients'"><b>{{ this.locale.registered_no }}: </b>{{this.selected_client_info['registered_no']}} <b class="pl-5">{{ this.locale.name }}: </b>-->
<!--              {{this.selected_client_info['name']}}-->
<!--              <b class="pl-5">{{ this.locale.phone }}: </b>{{this.selected_client_info['client_phone_number']}} <b class="pl-5">{{-->
<!--                  this.locale.address-->
<!--                }}: </b>-->
<!--              {{this.selected_client_info['full_address']}}</p>-->
        </div>
          <el-table id="shits-table" stripe :data="workUnitesFiltered" border
                    :summary-method="getSummaries"
                    show-summary>
            <el-table-column type="expand">
              <template #default="props">
                <div class="mx-4">
                  <p>{{ locale.worker }}:<b> {{ props.row.worker_name }} ({{ props.row.pw_pidn }})</b></p>
                  <p>{{ locale.project_description }}:<b> {{ props.row.description }}</b></p>
                  <p>{{ locale.project_address }}:<b> {{ props.row.project_address }}</b></p>
                  <p>{{ locale.planned_start_date }}:<b> {{ props.row.project_planned_start_date }}</b></p>
                  <p>{{ locale.start_date }}:<b> {{ props.row.project_start_date }}</b></p>
                  <p>{{ locale.daily_report }}:<b> {{ props.row.desc }}</b></p>
                </div>
              </template>
            </el-table-column>

            <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                sortable
                :label="column.label"
            >
            </el-table-column>
            <el-table-column v-if="for_which !== 'projects'"
                             prop="project_name"
                             v-bind:label="locale.project_name"
                             sortable
                             :sort-method="sortPName"
                             :min-width="200"
            />
            <!--                :filters="projects"-->
            <!--                :filter-method="filterHandler"-->
            <el-table-column v-if="for_which !== 'clients'"
                             prop="client_name"
                             v-bind:label="locale.client"
                             sortable
                             :sort-method="sortKund"
                             :min-width="180"
            />
            <!--                :filters="clients"-->
            <!--                :filter-method="filterHandler"-->
            <el-table-column v-if="for_which !== 'workers'"
                             prop="worker_name"
                             v-bind:label="locale.worker"
                             sortable
                             :min-width="180"
            />
            <!--                :filters="workers"-->
            <!--                :filter-method="filterHandler"-->
            <el-table-column
                prop="project_manager_name"
                v-bind:label="locale.project_manager"
                :min-width="200"
            />
            <el-table-column id="wu_actions" :min-width="135" fixed="right" label="Actions">
              <div
                  slot-scope="{ row }"
                  class="table-actions"
                  style="margin-left: 10px"
              >
                <el-tooltip content="Edit" :open-delay="300" placement="top"
                            v-if="logged_user_role == 'Admin'">
                  <n-button
                      @click.native="onEditWorkUnit(row.id)"
                      type="info"
                      size="sm"
                      round
                      icon
                  >
                    <i class="now-ui-icons ui-2_settings-90"></i>
                  </n-button>
                </el-tooltip>

                <el-tooltip content="Delete" :open-delay="300" placement="top"
                            v-if="logged_user_role == 'Admin'">
                  <n-button
                      @click.native="onDeleteWorkUnit(row.id)"
                      class="remove"
                      type="danger"
                      size="sm"
                      round
                      icon
                  >
                    <i class="fa fa-times"></i>
                  </n-button>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        <div id="toExcel" class="d-none">
          <el-table ref="elTable" id="shits-table" stripe :data="workUnitesFiltered" border
                    :summary-method="getSummaries"
                    show-summary>
            <el-table-column prop="data" label="info">

            </el-table-column>
            <el-table-column prop="data2" label="info2">

            </el-table-column>
            <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                sortable
                :label="column.label"
            >
            </el-table-column>
            <el-table-column v-if="for_which !== 'projects'"
                             prop="project_name"
                             v-bind:label="locale.project_name"
                             sortable
                             :min-width="200"
                             :filters="projects"
                             :filter-method="filterHandler"
            />
            <el-table-column v-if="for_which !== 'clients'"
                             prop="client_name"
                             v-bind:label="locale.client"
                             sortable
                             :min-width="180"
                             :filters="clients"
                             :filter-method="filterHandler"
            />
            <el-table-column v-if="for_which !== 'workers'"
                             prop="worker_name"
                             v-bind:label="locale.worker"
                             sortable
                             :min-width="180"
                             :filters="workers"
                             :filter-method="filterHandler"
            />
            <el-table-column
                prop="project_manager_name"
                v-bind:label="locale.project_manager"
                :min-width="200"
            />
          </el-table>
        </div>
        <modal name="work-unit-form" :adaptive="true"
               height="auto" :scrollable="true" :minHeight="500">
          <div style="margin: 1em; margin-top: 2em;">
            <n-button style="position: absolute;top: 0;right: 1%;"
                      @click.native="onModalHide('work-unit-form')"
                      class="remove text-end close-modal-btn"
                      type="danger"
                      size="sm"
                      round
                      icon
            >
              <i class="fa fa-times"></i>
            </n-button>
              <div class="d-flex flex-column">
                  <div class="d-flex adaptive-row adaptive-justify-content">
                      <div class="mb-3 d-flex flex-column adaptive-row-child-width">
                          <span>{{ locale.select_project }}:* </span>
                          <select :disabled="selected_project_id != ''" v-model="wu_selected_project" >
                              <option v-for="project in projects_add" v-bind:value="project.id" v-bind:key="project.id">
                                  {{ '(' + (project.client_project_number ? project.client_project_number : '') + ') ' +  project.name }}
                              </option>
                          </select>
                      </div>
                      <div class="mb-3 d-flex flex-column adaptive-row-child-width">
                          <span>{{ locale.select_worker }}:* </span>
                          <el-select :disabled="selected_worker_id != ''" :popper-append-to-body="false" v-model="wu_selected_worker"
                                     value-key="id" v-bind:placeholder="locale.select_worker" filterable remote>
                              <el-option
                                      v-for="worker in provider_workers"
                                      :key="worker.id"
                                      :label="worker.label"
                                      :value="worker.id"
                              />
                          </el-select>
                      </div>
                </div>
                <div class="d-flex flex-row justify-content-around">
                      <div class="d-flex flex-column adaptive-worker-select-width">
                          <span>{{ locale.select_date }}:* </span>
                          <input type="date" v-model="wu_selected_date" class="date mb-3">
                      </div>
                  </div>
                  <div class="d-flex adaptive-row adaptive-justify-content">
                      <div class="mb-3 d-flex flex-column adaptive-row-child-width">
                          <span>{{ locale.select_start }}:* </span>
                          <el-time-picker
                                  @change="calcEndTime"
                                  v-model="wu_selected_start"
                                  format="HH:mm"
                                  class="w-100"
                          />
                      </div>
                      <div class="mb-3 d-flex flex-column adaptive-row-child-width">
                        <span>{{ locale.select_stop }}:* </span>
                        <el-time-picker
                                v-model="wu_selected_stop"
                                class="w-100"
                                format="HH:mm">
                        </el-time-picker>
                      </div>
                  </div>
              <div class="d-flex flex-row justify-content-around">
                  <div class="d-flex flex-column adaptive-worker-select-width">
                      <span>{{ locale.daily_report }}:* </span>
                      <div class = "d-flex justify-content-between">
                          <div class="d-flex flex-column w-100  ">
                              <textarea maxlength=120  v-model="wu_selected_desc" style = "height: 5rem; text-align: start"></textarea>
                          </div>
                      </div>
                  </div>
              </div>
              <br>
              <div class="over600">
                  <div class="d-flex flex-row justify-content-around">
                      <div class = "d-flex justify-content-between adaptive-worker-select-width">
                          <div class="d-flex flex-column w-15">
                              <el-checkbox class="col" @change.native="calcEndTime" v-model="halfHour" label="1/2 h" size="large" border/>
                          </div>
                          <div class="d-flex flex-column w-15">
                              <el-checkbox class="col" @change.native="calcEndTime" v-model="hour" label="1 h" size="large" border/>
                          </div>
                          <div class="d-flex flex-column w-15">
                              <el-checkbox class="col" @change.native="calcEndTime" v-model="twoHour" label="2 h" size="large" border/>
                          </div>
                          <div class="d-flex flex-column w-15">
                              <el-checkbox class="col" @change.native="calcEndTime" v-model="fourHour" label="4 h" size="large" border/>
                          </div>
                          <div class="d-flex flex-column w-15">
                              <el-checkbox class="col" @change.native="calcEndTime" v-model="eightHour" label="8 h" size="large" border/>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="below600">
                  <div class="mb-3 d-flex flex-row justify-content-around">
                      <div class = "d-flex justify-content-between adaptive-worker-select-width">
                          <div class="d-flex flex-column w-25">
                              <el-checkbox class="col" @change.native="calcEndTime" v-model="halfHour" label="1/2 h" size="large" border/>
                          </div>
                          <div class="d-flex flex-column w-25">
                              <el-checkbox class="col" @change.native="calcEndTime" v-model="hour" label="1 h" size="large" border/>
                          </div>
                          <div class="d-flex flex-column w-25">
                              <el-checkbox class="col" @change.native="calcEndTime" v-model="twoHour" label="2 h" size="large" border/>
                          </div>
                      </div>
                  </div>
                  <div class="d-flex flex-row justify-content-around">
                      <div class = "d-flex justify-content-around adaptive-worker-select-width">
                          <div class="d-flex flex-column w-25">
                              <el-checkbox class="col" @change.native="calcEndTime" v-model="fourHour" label="4 h" size="large" border/>
                          </div>
                          <div class="d-flex flex-column w-25">
                              <el-checkbox class="col" @change.native="calcEndTime" v-model="eightHour" label="8 h" size="large" border/>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
            <div class ="d-flex flex-row justify-content-center">
                <el-tooltip content="Stop working on project" :open-delay="300" placement="top"
                            v-if="workings[upd_wu_id]">
                    <n-button
                            @click.native="showModalDesc()"
                            type="danger"
                            size="lg"
                            round
                            icon
                    >
                        <i class="fa fa-stop"></i>
                    </n-button>
                </el-tooltip>
            </div>
            <div style="text-align: center">
              <n-button v-if="modal_type == 'add'"
                        type="primary"
                        class="btn btn-sm btn-primary"
                        :class="{disabled: !checkRequires()}"
                        @click.native="addWorkUnit()"
              >
                <span >{{ locale.add_work_unit }}</span>
              </n-button>
              <n-button v-if="modal_type == 'update'"
                        type="primary"
                        class="btn btn-sm btn-primary"
                        :class="{disabled: !checkRequires()}"
                        @click.native="editWorkUnit()"
              >
                <span >{{ locale.update_work_unit }}</span>
              </n-button>

            </div>
          </div>
        </modal>

        <modal name="report-form" :adaptive="true" :scrollable="true" class="report-form">
          <div style="margin: 1em; margin-top: 2em;">
            <n-button
                @click.native="onModalHide('report-form')"
                class="remove text-end close-modal-btn"
                type="danger"
                size="sm"
                style="position: absolute; top: 0 ; right: 1%"
                round
                icon
            >
              <i class="fa fa-times"></i>
            </n-button>
            <div class="mb-3 d-flex flex-column w-100">
              <span class="w-100">{{ locale.daily_report }}: </span>
              <textarea maxlength=120  v-model="wu_description" style = "height: 5rem; text-align: start"></textarea>
            </div>
            <div style = "text-align: right">
              <n-button
                  type="primary"
                  class="btn btn-sm btn-primary"
                  @click.native="onStopProject(wu_selected_project)"
              >
                <span>{{ locale.send }}</span>
              </n-button>
            </div>
          </div>
        </modal>
        <!--        <div slot="footer" class="card-footer d-flex justify-content-end">-->
        <!--          <n-pagination v-model="page" @click.native="changePage()" class="pagination-no-border" :total="this.workUnitesFiltered.length">-->
        <!--          </n-pagination>-->
        <!--        </div>-->
      </card>
    </div>
  </div>
</template>
<script>
import {Table, TableColumn, Select, Option, DatePicker, TimePicker, Checkbox} from "element-ui";
// import {Pagination as NPagination} from "src/components";
import printJS from 'print-js'
import elTableExport from "el-table-export";
// import Exceljs from "exceljs/index";
import * as Excel from "exceljs";
import { saveAs } from 'file-saver';


const url = process.env.VUE_APP_API_BASE_URL;

export default {
  components: {
    // NPagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimePicker.name]: TimePicker,
    [Checkbox.name]: Checkbox,
  },

  data() {
    return {
      page: 1,
      pageSize: 10,

      selected_worker_info: [],
      selected_project_info: [],
      selected_client_info: [],
      selected_worker_id: '',
      selected_project_id: '',
      selected_client_id: '',
      locale: '',
      total: 0,
      wu_selected_project: '',
      wu_selected_worker: '',
      wu_selected_date: '',
      wu_selected_start: '',
      wu_selected_stop: '',
      wu_description: '',
      upd_wu_id: '',
      provider_workers: [],
      workUnites: [],
      workUnitesFiltered: [],
      workUnitesFilteredPaged: [],
      workUnitesFilteredPrint: [],
      projects: [],
      clients: [],
      workers: [],
      for_which: '',
      profile_company: [],
      halfHour: false,
      hour: false,
      twoHour: false,
      fourHour: false,
      eightHour: false,
      tableColumns: [
        {
          prop: "start",
          label: this.$getLocale().date,
          minWidth: 150,
        },
        // {
        //   prop: "stop",
        //   label: this.$getLocale().stop,
        //   minWidth: 150,
        // },
        {
          prop: "total_time",
          label: this.$getLocale().total,
          minWidth: 100,
        },

      ],
      totalTimeSum: '',
      logged_user_role: '',
      projects_add: [],
      selected_date_range: [],
      selected_week: '',
      accepted_filters: [],
      modal_type: '',
      wu_selected_desc: '',

      workings: [],
    };
  },

  methods: {
    sortPName(a,b) {
        if (a.project_name.toUpperCase() <  b.project_name.toUpperCase()) return -1;
        if (a.project_name.toUpperCase() > b.project_name.toUpperCase()) return 1;
        return 0;
    },
    sortKund(a,b) {
        if (a.client_name.toUpperCase() <  b.client_name.toUpperCase()) return -1;
        if (a.client_name.toUpperCase() > b.client_name.toUpperCase()) return 1;
        return 0;
    },

    changePage() {
      // this.clientsPaged = this.clients.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
    },

    checkRequires() {
      return (this.wu_selected_project != '' && this.wu_selected_project != null && this.wu_selected_worker != '' && this.wu_selected_worker != null && this.wu_selected_date != '' && this.wu_selected_date != null
          && this.wu_selected_start != '' && this.wu_selected_start != null && this.wu_selected_stop != '' && this.wu_selected_stop != null)
    },

    printTable(id) {
      let printJson = [];
      let properties = [];
      let headers = '<span style="font-weight: bold; font-size: 12px;">' + this.locale.company + ': </span>'
          + (this.profile_company.name ? this.profile_company.name : '') + '<hr>';
      if (this.for_which == 'workers') {
        properties = [
          { field: 'start', displayName: this.locale.start},
          // { field: 'stop', displayName: this.locale.stop},
          { field: 'total', displayName: this.locale.total},
          { field: 'project_name', displayName: this.locale.project_name},
          { field: 'client_name', displayName: this.locale.client_name},
          { field: 'project_manager_name', displayName: this.locale.project_manager},
          { field: 'desc', displayName: this.locale.daily_report},
        ];
        let selected_date_period = '';
        if (this.selected_week) {
          let date = new Date();
          selected_date_period = this.selected_week.toLocaleDateString('sv-SV') + ' - ' + new Date(date.setTime(this.selected_week.getTime() + (7 * 24 * 60 * 60 * 1000))).toLocaleDateString('sv-SV');
          properties = properties.filter(elem => elem.field != 'stop');
        }
        if (this.selected_date_range.length !== 0)
        {
          let selected_start = new Date(this.selected_date_range[0]);
          let selected_end = new Date(this.selected_date_range[1]);
          selected_date_period = selected_start.toLocaleDateString('sv-SV') + ' - ' + selected_end.toLocaleDateString('sv-SV');
          properties = properties.filter(elem => elem.field != 'stop');
        }
        headers += '<div style="display: flex; justify-content: space-between; font-size: 12px;"><span>' + '<span style="font-weight: bold;">' + this.locale.employment_number + ': </span>'
            + (this.selected_worker_info['employment_number'] ? this.selected_worker_info['employment_number'] : '') + '</span>' + '<span>' + selected_date_period + '</span>' + '</div>';
        headers += '<span style="font-weight: bold; font-size: 12px;">' + this.locale.first_name + ': </span>'
            + (this.selected_worker_info['first_name'] ? this.selected_worker_info['first_name'] : '') + '<br>';
        headers += '<span style="font-weight: bold; font-size: 12px;">' + this.locale.last_name + ': </span>'
            + (this.selected_worker_info['last_name'] ? this.selected_worker_info['last_name'] : '') + '<br>';
        headers += '<span style="font-weight: bold; font-size: 12px;">' + this.locale.personal_no + ': </span>'
            + (this.selected_worker_info['personal_id_no'] ? this.selected_worker_info['personal_id_no'] : '') + '<br>';
        headers += '<span style="font-weight: bold; font-size: 12px;">' + this.locale.phone + ': </span>'
            + (this.selected_worker_info['phone'] ? this.selected_worker_info['phone'] : '') + '<hr>';
      }
      if (this.for_which == 'projects') {
        properties = [
          { field: 'start', displayName: this.locale.start},
          // { field: 'stop', displayName: this.locale.stop},
          { field: 'total', displayName: this.locale.total},
          { field: 'worker', displayName: this.locale.worker},
          { field: 'client_name', displayName: this.locale.client_name},
          { field: 'project_manager_name', displayName: this.locale.project_manager},
        ];
        let selected_date_period = '';
        if (this.selected_week) {
          let date = new Date();
          selected_date_period = this.selected_week.toLocaleDateString('sv-SV') + ' - ' + new Date(date.setTime(this.selected_week.getTime() + (7 * 24 * 60 * 60 * 1000))).toLocaleDateString('sv-SV');
          properties = properties.filter(elem => elem.field != 'stop');
        }
        if (this.selected_date_range.length !== 0)
        {
          let selected_start = new Date(this.selected_date_range[0]);
          let selected_end = new Date(this.selected_date_range[1]);
          selected_date_period = selected_start.toLocaleDateString('sv-SV') + ' - ' + selected_end.toLocaleDateString('sv-SV');
          properties = properties.filter(elem => elem.field != 'stop');
        }
        headers += '<div style="display: flex; justify-content: space-between; font-size: 12px;"><span>' + '<span style="font-weight: bold;">' + this.locale.own_project_number + ': </span>'
            + (this.selected_project_info['own_project_number'] ? this.selected_project_info['own_project_number'] : '') + '</span>' + '<span>' + selected_date_period + '</span>' + '</div>';
        headers += '<span style="font-weight: bold; font-size: 12px;">' + this.locale.name + ': </span>'
            + (this.selected_project_info['name'] ? this.selected_project_info['name'] : '') + '<br>';
        headers += '<span style="font-weight: bold; font-size: 12px;">' + this.locale.client_project_number + ': </span>'
            + (this.selected_project_info['client_project_number'] ? this.selected_project_info['client_project_number'] : '') + '<br>';
        headers += '<span style="font-weight: bold; font-size: 12px;">' + this.locale.address + ': </span>'
            + (this.selected_project_info['full_address'] ? this.selected_project_info['full_address'] : '') + '<hr>';
      }
      if (this.for_which == 'clients') {
        properties = [
          { field: 'start', displayName: this.locale.start},
          // { field: 'stop', displayName: this.locale.stop},
          { field: 'total', displayName: this.locale.total},
          { field: 'project_name', displayName: this.locale.project_name},
          { field: 'worker', displayName: this.locale.worker},
          { field: 'project_manager_name', displayName: this.locale.project_manager},
        ];
        let selected_date_period = '';
        if (this.selected_week) {
          let date = new Date();
          selected_date_period = this.selected_week.toLocaleDateString('sv-SV') + ' - ' + new Date(date.setTime(this.selected_week.getTime() + (7 * 24 * 60 * 60 * 1000))).toLocaleDateString('sv-SV');
          properties = properties.filter(elem => elem.field != 'stop');
        }
        if (this.selected_date_range.length !== 0)
        {
          let selected_start = new Date(this.selected_date_range[0]);
          let selected_end = new Date(this.selected_date_range[1]);
          selected_date_period = selected_start.toLocaleDateString('sv-SV') + ' - ' + selected_end.toLocaleDateString('sv-SV');
          properties = properties.filter(elem => elem.field != 'stop');
        }
        headers += '<div style="display: flex; justify-content: space-between; font-size: 12px;"><span>' + '<span style="font-weight: bold;">' + this.locale.personal_no + ': </span>'
            + (this.selected_client_info['personal_id_no'] ? this.selected_client_info['personal_id_no'] : '') + '</span>' + '<span>' + selected_date_period + '</span>' + '</div>';
        headers += '<span style="font-weight: bold; font-size: 12px;">' + this.locale.name + ': </span>'
            + (this.selected_client_info['name'] ? this.selected_client_info['name'] : '') + '<br>';
        headers += '<span style="font-weight: bold; font-size: 12px;">' + this.locale.phone + ': </span>'
            + (this.selected_client_info['phone'] ? this.selected_client_info['phone'] : '') + '<br>';
        headers += '<span style="font-weight: bold; font-size: 12px;">' + this.locale.address + ': </span>'
            + (this.selected_client_info['full_address'] ? this.selected_client_info['full_address'] : '') + '<hr>';
      }
      for (let i = 0; i < this.workUnitesFiltered.length; i++) {
        if (this.for_which == 'workers') {
          printJson[i] = {
            start: this.workUnitesFiltered[i].start ? this.workUnitesFiltered[i].start : '',
            stop: this.workUnitesFiltered[i].stop ? this.workUnitesFiltered[i].stop : '',
            total: this.workUnitesFiltered[i].total_time ? this.workUnitesFiltered[i].total_time : '',
            project_name: this.workUnitesFiltered[i].project_name,
            client_name: this.workUnitesFiltered[i].client_name,
            project_manager_name: this.workUnitesFiltered[i].project_manager_name + ' '  + this.workUnitesFiltered[i].project_manager_surname,
            desc: this.workUnitesFiltered[i].desc,
          }
        }
        if (this.for_which == 'projects') {
          printJson[i] = {
            start: this.workUnitesFiltered[i].start ? this.workUnitesFiltered[i].start : '',
            stop: this.workUnitesFiltered[i].stop ? this.workUnitesFiltered[i].stop : '',
            total: this.workUnitesFiltered[i].total_time ? this.workUnitesFiltered[i].total_time : '',
            worker: this.workUnitesFiltered[i].worker_name + ' ' + this.workUnitesFiltered[i].worker_surname,
            client_name: this.workUnitesFiltered[i].client_name,
            project_manager_name: this.workUnitesFiltered[i].project_manager_name + ' '  + this.workUnitesFiltered[i].project_manager_surname,
          }
        }
        if (this.for_which == 'clients') {
          printJson[i] = {
            start: this.workUnitesFiltered[i].start ? this.workUnitesFiltered[i].start : '',
            stop: this.workUnitesFiltered[i].stop ? this.workUnitesFiltered[i].stop : '',
            total: this.workUnitesFiltered[i].total_time ? this.workUnitesFiltered[i].total_time : '',
            project_name: this.workUnitesFiltered[i].project_name,
            worker: this.workUnitesFiltered[i].worker_name + ' ' + this.workUnitesFiltered[i].worker_surname,
            project_manager_name: this.workUnitesFiltered[i].project_manager_name + ' '  + this.workUnitesFiltered[i].project_manager_surname,
          }
        }
      }
      printJson.push({
        start: this.totalTimeSum[1],
        stop: '',
        project_name: '',
        client_name: '',
        project_manager_name: '',
        worker: '',
        total: this.totalTimeSum[2],
        desc:'',
      });
      printJS({
        printable: printJson,
        properties: properties,
        header: headers,
        type: 'json',
        gridHeaderStyle: 'font-size: 12px; border: 1px solid black;',
        gridStyle: 'font-size: 10px; border: 1px solid black;'
      })

    },

    exportExcel() {
      const starts = this.workUnitesFiltered.map((e) => e.start);
      const stops = this.workUnitesFiltered.map((e) => e.stop);
      var dates = starts.concat(stops);
      dates = dates.map((e) => new Date(e));
      const samplePeriod = new Date(Math.min(...dates)).toLocaleDateString('sv-SV') + "/" +  new Date(Math.max(...dates)).toLocaleDateString('sv-SV');
      const workbook = new Excel.Workbook();
      workbook.addWorksheet('Report', {properties:{}});
      const ws = workbook.getWorksheet('Report');
      ws.columns = [
          {width : 25},{width : 25},{width : 7}, {width : 25}, {width: 30}, {width: 25}, {width : 40}
      ]
      const alphabet = [];

      for (let i = 65; i <= 90; i++) {
          alphabet.push(String.fromCharCode(i));
      }

      if (this.for_which == 'workers') {
          ws.addRow([this.locale.Worker_report]);
          ws.addRow([this.locale.employment_number, this.selected_worker_info['employment_number'] ? this.selected_worker_info['employment_number'] : '']);
          ws.addRow([this.locale.first_name, (this.selected_worker_info['first_name'] ? this.selected_worker_info['first_name'] : '')]);
          ws.addRow([this.locale.last_name, (this.selected_worker_info['last_name'] ? this.selected_worker_info['last_name'] : '')]);
          ws.addRow([this.locale.personal_no, (this.selected_worker_info['personal_id_no'] ? this.selected_worker_info['personal_id_no'] : '')]);
          ws.addRow([this.locale.phone, (this.selected_worker_info['phone'] ? this.selected_worker_info['phone'] : '')]);
          ws.addRow([this.locale.Report_date, (new Date().toLocaleDateString('sv-SV'))]);
          ws.addRow([this.locale.Sample_period, samplePeriod]);
          ws.addRow([]);
          ws.addRow([this.locale.start,this.locale.stop, this.locale.total, this.locale.project_name,this.locale.client_name , this.locale.project_manager , this.locale.daily_report]);
          this.workUnitesFiltered.forEach(function(RowItem, RowIndex) {
              ws.addRow([RowItem.start ? RowItem.start : '', RowItem.stop ? RowItem.stop : '', RowItem.total_time ? RowItem.total_time : '',
                  RowItem.project_name ? RowItem.project_name : '', RowItem.client_name ? RowItem.client_name : '', RowItem.project_manager_name ? RowItem.project_manager_name + ' ' + RowItem.project_manager_surname : '',
                  RowItem.desc ? RowItem.desc : '' ]);
              // if (RowItem.project_name.length > 25) {
              //     ws.getRow(RowIndex + 11).height = 40;
              // }
              // if (RowItem.desc.length > 40) {
              //     if (RowItem.desc.length > 80) {
              //         ws.getRow(RowIndex + 11).height = 60;
              //     }
              //     else {
              //         ws.getRow(RowIndex + 11).height = 35;
              //     }
              // }
          });

          //Bold header
          for (let i = 1;i < 9;++i) {
              ws.getCell("A" + i.toString()).font = {
                  bold: true
              }
          }
          //Bold table header
          for (let i = 0; i < 8;++i) {
              ws.getCell(alphabet[i] + "10").font = {
                  bold: true
              }
          }
      }
      if (this.for_which == 'projects') {
          ws.addRow([this.locale.Project_report]);
          ws.addRow([this.locale.own_project_number, this.selected_project_info['own_project_number'] ? this.selected_project_info['own_project_number'] : '']);
          ws.addRow([this.locale.name, this.selected_project_info['name'] ? this.selected_project_info['name'] : '']);
          ws.addRow([this.locale.client_project_number, this.selected_project_info['client_project_number'] ? this.selected_project_info['client_project_number'] : '']);
          ws.addRow([this.locale.address, this.selected_project_info['full_address'] ? this.selected_project_info['full_address'] : '']);
          ws.addRow([this.locale.Report_date, new Date().toLocaleDateString('sv-SV')]);
          ws.addRow([this.locale.Sample_period, samplePeriod]);
          ws.addRow([]);
          ws.addRow([this.locale.start,this.locale.stop, this.locale.total, this.locale.worker,this.locale.client_name , this.locale.project_manager , this.locale.daily_report]);
          this.workUnitesFiltered.forEach(function(RowItem, RowIndex) {
              ws.addRow([RowItem.start ? RowItem.start : '', RowItem.stop ? RowItem.stop : '', RowItem.total_time ? RowItem.total_time : '',
                  RowItem.worker_name ? RowItem.worker_name + ' ' + RowItem.worker_surname : '', RowItem.client_name ? RowItem.client_name : '', RowItem.project_manager_name ? RowItem.project_manager_name +  ' ' + RowItem.project_manager_surname : '',
                  RowItem.desc ? RowItem.desc : '' ]);
          });
          //Bold header
          for (let i = 1;i < 9;++i) {
              ws.getCell("A" + i.toString()).font = {
                  bold: true
              }
          }
          //Bold table header
          for (let i = 0; i < 7;++i) {
              ws.getCell(alphabet[i] + "9").font = {
                  bold: true
              }
          }
      }
      if (this.for_which == 'clients') {
        ws.addRow([this.locale.Client_report]);
        ws.addRow([this.locale.personal_no, this.selected_client_info['registered_no'] ? this.selected_client_info['registered_no'] : '']);
        ws.addRow([this.locale.name, this.selected_client_info['name'] ? this.selected_client_info['name'] : '']);
        ws.addRow([this.locale.phone,this.selected_client_info['phone'] ? this.selected_client_info['phone'] : '']);
        ws.addRow([this.locale.address,this.selected_client_info['full_address'] ? this.selected_client_info['full_address'] : '']);
        ws.addRow([this.locale.Report_date, new Date().toLocaleDateString('sv-SV')]);
        ws.addRow([this.locale.Sample_period, samplePeriod]);
        ws.addRow([]);
        ws.addRow([this.locale.start,this.locale.stop, this.locale.total, this.locale.worker,this.locale.project_name , this.locale.project_manager , this.locale.daily_report]);
        console.log(this.workUnitesFiltered);
        this.workUnitesFiltered.forEach(function(RowItem, RowIndex) {
            ws.addRow([RowItem.start ? RowItem.start : '', RowItem.stop ? RowItem.stop : '', RowItem.total_time ? RowItem.total_time : '',
                RowItem.worker_name ? RowItem.worker_name + ' ' + RowItem.worker_surname : '', RowItem.client_name ? RowItem.project_name : '', RowItem.project_manager_name ? RowItem.project_manager_name +  ' ' + RowItem.project_manager_surname : '',
                RowItem.desc ? RowItem.desc : '' ]);
        });
        //Bold header
        for (let i = 1;i < 9;++i) {
            ws.getCell("A" + i.toString()).font = {
                bold: true
            }
        }
        //Bold table header
        for (let i = 0; i < 8;++i) {
            ws.getCell(alphabet[i] + "9").font = {
                bold: true
            }
        }
      }
      //Save excel
      workbook.xlsx.writeBuffer()
          .then(buffer => saveAs(new Blob([buffer]), "working-hours.xls"));
    },

    getWUFiltered() {
      if (!this.selected_worker_id && this.for_which == 'workers') {
        this.workUnitesFiltered = [];
        return;
      }
      if (!this.selected_project_id && this.for_which == 'projects') {
        this.workUnitesFiltered = [];
        return;
      }

      if (!this.selected_client_id && this.for_which == 'clients') {
        this.workUnitesFiltered = [];
        return;
      }

      this.workUnitesFiltered = this.workUnites;
      if (this.selected_worker_id && this.for_which == 'workers')
      {
        this.workUnitesFiltered = this.workUnitesFiltered.filter(elem => elem.pw_id == this.selected_worker_id);
        let pw = this.provider_workers.filter(elem => elem.id == this.selected_worker_id)[0];
        this.selected_worker_info['employment_number'] = pw.employment_number;
        this.selected_worker_info['first_name'] = pw.first_name;
        this.selected_worker_info['last_name'] = pw.last_name;
        this.selected_worker_info['personal_id_no'] = pw.personal_id_no;
        this.selected_worker_info['address_line1'] = pw.address_line1;
        this.selected_worker_info['address_line2'] = pw.address_line2;
        this.selected_worker_info['postal_code'] = pw.postal_code;
        this.selected_worker_info['city'] = pw.city;
        this.selected_worker_info['phone'] = pw.phone;
      }
      if (this.selected_project_id && this.for_which == 'projects')
      {
        this.workUnitesFiltered = this.workUnitesFiltered.filter(elem => elem.project_id == this.selected_project_id);
        let pr = this.projects_add.filter(elem => elem.id == this.selected_project_id)[0];
        this.selected_project_info['own_project_number'] = pr.own_project_number;
        this.selected_project_info['name'] = pr.name;
        this.selected_project_info['client_project_number'] = pr.client_project_number;
        this.selected_project_info['full_address'] = pr.full_address;
      }
      if (this.selected_client_id && this.for_which == 'clients')
      {
        this.workUnitesFiltered = this.workUnitesFiltered.filter(elem => elem.c_id == this.selected_client_id);
        let cl = this.clients.filter(elem => elem.client_id == this.selected_client_id)[0];

        this.selected_client_info['registered_no'] = cl.registered_no;
        this.selected_client_info['name'] = cl.name;
        this.selected_client_info['phone'] = cl.phone;
        this.selected_client_info['full_address'] = cl.full_address;
      }
      if (this.selected_week)
      {
        if (!this.selected_date_range)
          this.selected_date_range = [];
        this.selected_date_range[0] = new Date(this.selected_week);
        var days = 7;
        var date = new Date();
        var res = date.setTime(this.selected_date_range[0].getTime() + (days * 24 * 60 * 60 * 1000));

        this.selected_date_range[1] = new Date(res);

        this.dateRangeFilter();

        this.selected_date_range = [];
      }
      if (this.selected_date_range.length !== 0)
      {
        this.dateRangeFilter();
      }
    },

    dateRangeFilter()
    {
      if (!this.selected_date_range) {
        this.workUnitesFiltered = this.workUnites;
        return;
      }
      let cnt_in_progress = 0;
      this.workUnitesFiltered = this.workUnitesFiltered.filter(elem => {
        let selected_start = new Date(this.selected_date_range[0]);
        let selected_end = new Date(this.selected_date_range[1]);
        selected_end = new Date(selected_end.setDate(selected_end.getDate() + 1));
        let wu_start = new Date(elem.start);
        let wu_stop = new Date(elem.stop);
        if (!elem.stop && (wu_start.getTime() >= selected_start.getTime() && wu_start.getTime() < selected_end.getTime()))
          cnt_in_progress++;
        return elem.stop && (wu_start.getTime() >= selected_start.getTime() && wu_stop.getTime() < selected_end.getTime());
      });
      if (cnt_in_progress)
        alert('There are ' + cnt_in_progress + 'work shifts in progress that have been ignored in calculation');
    },

    filterHandler(value, row, column) {
      const property = column['property'];
      if (row[property] !== value) {
        // this.workUnitesFilteredPrint = this.workUnitesFiltered;
        let index = this.workUnitesFilteredPrint.indexOf(this.workUnitesFilteredPrint.find(function (element) {
          return element[property] !== value
        }));
        this.workUnitesFilteredPrint.splice(index, 1);
      }
      if (row[property] === value && !this.accepted_filters[property])
        this.accepted_filters[property] = value;
      if (row[property] === value && this.accepted_filters[property] && !this.accepted_filters[property].includes(value))
        this.accepted_filters[property] += ', ' + value;

      return row[property] === value;
    },

    getSummaries(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          let total_for = '';
          sums[index] = this.$getLocale().total_hours + ' ' + total_for;
          return
        }

        if (column.property != 'total_time')
          return;

        const times = data.map((item) => (item[column.property]))
        let hours = 0;
        let minutes = 0;
        for (const i in times) {
          const time = times[i];
          if (!time)
            continue;
          let splitTime = (time + "").split(":"); // make sure it's a string
          minutes += parseInt(splitTime[1]);
          if (minutes > 59) { // make sure it only goes until 59
            hours++;
            minutes = minutes % 60;
          }
          hours += parseInt(splitTime[0]);
        }
        let totalTime = (hours < 10 ? "0" + hours : hours) + ":"
            + (minutes < 10 ? "0" + minutes : minutes)
        sums[index] = totalTime;
      })
      this.totalTimeSum = sums;
      return sums
    },

    pushProjects(elem) {
      if (!this.projects.some(element => {
        return element.value == elem.project_name;
      }))
        this.projects.push({'value': elem.project_name, 'text': elem.project_name});
    },

    pushClients(elem) {
      if (!this.clients.some(element => {
        return element.value == elem.client_name;
      }))
        this.clients.push({'value': elem.client_name, 'text': elem.client_name});
    },

    pushWorkers(elem) {
      if (!this.workers.some(element => {
        return element.value == elem.worker_name;
      }))
        this.workers.push({'value': elem.worker_name, 'text': elem.worker_name});
    },

    onModalHide(name) {
      this.$modal.hide(name);
    },
    calcEndTime() {
      let sumh = 0;
      let summ = 0;
      if (this.halfHour)
        summ += 30;
      if (this.hour)
        sumh += 1;
      if (this.twoHour)
        sumh += 2;
      if (this.fourHour)
        sumh += 4;
      if (this.eightHour)
        sumh += 8;
      this.wu_selected_stop = new Date(null,null,null,this.wu_selected_start.getHours() + sumh,this.wu_selected_start.getMinutes() + summ);
    },
    onAddWorkUnit() {
      this.halfHour = false;
      this.hour = false;
      this.twoHour = false;
      this.fourHour = false;
      this.eightHour = false;
      this.wu_selected_project = this.selected_project_id ? parseInt(this.selected_project_id) : '';
      this.wu_selected_worker = this.selected_worker_id ? parseInt(this.selected_worker_id) : '';
      this.wu_selected_date = '';
      this.wu_selected_start = new Date(null,null,null,7,0);
      this.wu_selected_stop = new Date(null,null,null,16,0);
      this.modal_type = 'add';
      this.wu_selected_desc = '';
      this.$modal.show('work-unit-form');
    },

    async addWorkUnit() {
      let wu_data = {
        'project_id': this.wu_selected_project,
        'provider_staff_id': this.wu_selected_worker,
        'start': this.wu_selected_date + ' ' + this.wu_selected_start.toLocaleTimeString('sv-SE'),
        'stop': this.wu_selected_date + ' ' + this.wu_selected_stop.toLocaleTimeString('sv-SE'),
        'desc': this.wu_selected_desc,
      };
      const requestOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(wu_data)
      };
      await fetch(url + "/add-work-unit", requestOptions)
          .then(response => window.location.reload());
      this.$modal.hide('work-unit-form');
    },

    onEditWorkUnit(id) {
      this.halfHour = false;
      this.hour = false;
      this.twoHour = false;
      this.fourHour = false;
      this.eightHour = false;
      this.upd_wu_id = id;
      let updating_wu = this.workUnites.filter(elem => elem.id == id)[0];
      this.wu_selected_project = updating_wu.project_id;
      this.wu_selected_worker = updating_wu.pw_id;
      this.wu_selected_date = updating_wu.start.split(' ')[0];
      this.wu_selected_desc = updating_wu.desc;
      this.wu_selected_start = new Date(updating_wu.start);
      this.wu_selected_stop = new Date(updating_wu.stop);
      this.modal_type = 'update';
      this.$modal.show('work-unit-form');
    },

    async editWorkUnit() {
      let wu_data = {
        'project_id': this.wu_selected_project,
        'provider_staff_id': this.wu_selected_worker,
        'start': this.wu_selected_date + ' ' + this.wu_selected_start.toLocaleTimeString('sv-SE'),
        'stop': this.wu_selected_date + ' ' + this.wu_selected_stop.toLocaleTimeString('sv-SE'),
        'id': this.upd_wu_id,
        'desc': this.wu_selected_desc,
      };
      const requestOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(wu_data)
      };
      await fetch(url + "/update-work-unit", requestOptions)
          .then(response => window.location.reload());
      this.$modal.hide('work-unit-form');
    },

    async onDeleteWorkUnit(id) {
      let sure = confirm("Are you sure?");
      if (!sure)
        return;
      let wu_data = {
        'id': id,
      };
      const requestOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(wu_data)
      };
      await fetch(url + "/delete-work-unit", requestOptions)
          .then(response => window.location.reload());
    },

    showModalDesc() {
      this.$modal.show('report-form');
    },

    async onStopProject(id) {
      let project_data;
      if (this.wu_description !== '') {
        project_data = {
          'id': id,
          'desc': this.wu_description,
          'worker_id': this.wu_selected_worker
        };
      }
      else {
        project_data = {
          'id': id,
          'worker_id': this.wu_selected_worker
        };
      }
      const requestOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(project_data)
      };
      return await fetch(url + "/stop-project-work", requestOptions)
          .then(response => window.location.reload());
    },

    async getworkUnites() {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({'logged_role': this.logged_user_role})
      };
      return await fetch(url + '/list-work-units', requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response statusText
              const error = (data && data.message) || response.statusText;
              return Promise.reject(error);
            }

            this.workUnites = data;
            this.workUnites.forEach(elem => {
              elem.start = elem.start.slice(0, -3);
              elem.stop = elem.stop ? elem.stop.slice(0, -3) : null;
              let project_data = this.projects_add.filter(elem_add => elem_add.id == elem.project_id);

              if (project_data.address_line1 && project_data.address_line2) {
                elem.project_address = project_data.address_line1 + ', ' + project_data.address_line2;
              }
              this.pushProjects(elem);
              // this.pushClients(elem);
              this.pushWorkers(elem);
              this.workings[elem.id] = !elem.stop;
              elem.total_time = elem.stop ? ('0' + parseInt(elem.total ? parseInt(elem.total) / 60 : 0)).slice(-2) + ':' + ('0' + parseInt(elem.total ? elem.total % 60 : 0)).slice(-2) : null;
            });
            this.workUnitesFiltered = structuredClone(this.workUnites);
            this.workUnitesFilteredPrint = structuredClone(this.workUnites);
            this.total = data.length
            if (this.for_which == 'workers' || this.for_which == 'projects' || this.for_which == 'clients') {
              this.getWUFiltered();
            }
            this.changePage();
          })
          .catch(error => {
            this.errorMessage = error;
            console.error("There was an error!", error);
          });
    },

    async getProjects() {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({'logged_role': this.logged_user_role})
      };
      return await fetch(url + '/list-projects-workers', requestOptions)
          .then(async response => {
            let data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response statusText
              const error = (data && data.message) || response.statusText;
              return Promise.reject(error);
            }

            let already_added_ids = [];
            if (this.selected_worker_id) {
              data = data.filter(elem => elem.provider_staff_id == this.selected_worker_id)
            }
            data.forEach(elem => {
              elem.pw_id = [elem.pw_id];
              if (!already_added_ids.includes(elem.id)) {
                this.projects_add.push(elem);
                already_added_ids.push(elem.id);
              }
            });
          })
          .catch(error => {
            this.errorMessage = error;
            console.error("There was an error!", error);
          });
    },

    async getClients() {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({'logged_role': this.logged_user_role})
      };
      return await fetch(url + '/list-clients', requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response statusText
              const error = (data && data.message) || response.statusText;
              return Promise.reject(error);
            }

            this.clients = data;
          })
          .catch(error => {
            this.errorMessage = error;
            console.error("There was an error!", error);
          });
    },

    async getLoggedRole() {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({title: 'Vue POST Request Example'})
      };
      return await fetch(url + '/get-logged-role', requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response status
              const error = (data && data.message) || response.status;
              return Promise.reject(error);
            }

            this.logged_user_role = data[0].name;
            await this.getProjects();
            this.getClients();
            await this.getworkUnites();
          })
          .catch(error => {
            this.errorMessage = error;
            console.error('There was an error!', error);
          });
    },

    async getProviderWorkers() {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({title: 'Vue POST Request Example'})
      };
      return await fetch(url + '/list-workers-projects', requestOptions)
          .then(async response => {
            let data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response statusText
              const error = (data && data.message) || response.statusText;
              return Promise.reject(error);
            }

            let already_added_ids = [];
            if (this.selected_project_id) {
              data = data.filter(elem => elem.project_id == this.selected_project_id)
            }
            data.forEach(elem => {
              if (!already_added_ids.includes(elem.id)) {
                if (elem.employment_number)
                  elem.employment_number = elem.employment_number.toString().padStart(3, '0');
                elem.label = elem.first_name + ' ' + elem.last_name + ' (' + elem.employment_number + ')'
                this.provider_workers.push(elem);
                already_added_ids.push(elem.id);
              }
            });
          })
          .catch(error => {
            this.errorMessage = error;
            console.error("There was an error!", error);
          });
    },

    async getProfileCompany() {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({title: 'Vue POST Request Example'})
      };
      return await fetch(url + '/company-profile', requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response status
              const error = (data && data.message) || response.status;
              return Promise.reject(error);
            }

            this.profile_company = data[0];
          })
          .catch(error => {
            this.errorMessage = error;
            console.error('There was an error!', error);
          });
    },

    async getData() {
      await this.getProviderWorkers();
      await this.getLoggedRole();
      await this.getProfileCompany();
    },
  },

  created() {
    this.getData();
  },

  watch:{
    $route (to, from){
      this.for_which = Object.keys(to['query'])[0];
      window.location.reload();
    }
  },

  mounted() {
    this.locale = this.$getLocale();
    let query = window.location.search;
    const which = new URLSearchParams(query);
    this.for_which =  which.has('workers') ? 'workers' : which.has('projects') ? 'projects' : which.has('clients') ? 'clients' : '';
    if (this.for_which === 'workers')
      this.selected_worker_id = which.get('swid');
    if (this.for_which === 'projects')
      this.selected_project_id = which.get('spid');
    if (this.for_which === 'clients')
      this.selected_client_id = which.get('scid');
  },

};
</script>
<style scoped>
.vm--container.scrollable::v-deep .vm--modal {
    height: auto !important;
    overflow:hidden!important;
}
.adaptive-justify-content {
    justify-content: space-around;
}

@media (max-width: 600px) {
    .adaptive-justify-content {
        justify-content: space-between;
    }
}
.adaptive-row {
    display: flex;
    flex-direction: row;
}

@media (max-width: 600px) {
    .adaptive-row {
        display: flex;
        flex-direction: column;
        /*justify-content: center!important;*/
        align-items: center;
    }
}

.adaptive-row-child-width {
    width: 45%;
    margin-bottom: 1rem;
}

@media (max-width: 600px) {
    .adaptive-row-child-width {
        width: 100%;
        margin-bottom: 1rem;
    }
}

.adaptive-worker-select-width {
    width: 95%;
}

@media (max-width: 600px) {
    .adaptive-worker-select-width {
        width: 100%;
    }
}
</style>

<style>


.el-picker-panel__footer {
  font-size: small !important;
}

.w-40 {
  width: 44.5%;
}

.w-15 {
  width: 15%;
}

select {
  border-radius: 8px;
  background-color: white;
  height: 2rem;
}

input {
  border-radius: 8px;
  border: 1px solid grey;
  height: 2rem;
}

.col-2 {
  padding-left: 0;
  padding-right: 0;
}

.over600 {
  display: inline;
}
.below600 {
  display: none;
}
@media screen and (max-width: 600px) {
  .over600 {
    display: none;
  }
  .below600 {
    display: inline;
  }
}
.over400 {
  display: inline;
}
.below400 {
  display: none;
}
@media screen and (max-width: 400px) {
  .over400 {
    display: none;
  }
  .below400 {
    display: inline;
  }
}

.adaptive-margin {
  margin-left: 1rem;
  margin-right: 1rem;
}

@media (max-width: 600px) {
  .adaptive-margin {
    margin-left: 0;
    margin-right: 0;
  }
}
.report-form .vm--modal {
    max-height: 230px;
}
 td:first-child{
  z-index: 998;
  /*display: flex;*/
  /*flex-direction: row;*/
  /*flex-wrap: wrap;*/
}
</style>